import { defineStore } from 'pinia'
import { ref } from 'vue'
import api from '../lib/api'

export const useEventosStore = defineStore('eventos', () => {
  const eventos = ref([])
  const loading = ref(false)

  async function fetchAll() {
    loading.value = true
    try {
      const { data } = await api.get('/eventos')
      eventos.value = data.eventos
    } finally { loading.value = false }
  }

  async function getOne(id) {
    const { data } = await api.get(`/eventos/${id}`)
    return data.evento
  }

  async function create(payload) {
    const { data } = await api.post('/eventos', payload)
    eventos.value = [data.evento, ...eventos.value]
    return data.evento
  }

  async function update(id, payload) {
    const { data } = await api.patch(`/eventos/${id}`, payload)
    eventos.value = eventos.value.map(e => e.id === id ? { ...e, ...data.evento } : e)
    return data.evento
  }

  /**
   * Soft delete. Rota propria porque `DELETE /eventos/:id` e o arquivar.
   * Erro 409 vem com o motivo pronto do servidor.
   */
  async function deletar(id) {
    const { data } = await api.delete(`/eventos/${id}/permanente`)
    eventos.value = eventos.value.filter(e => e.id !== id)
    return data
  }

  async function archive(id) {
    await api.delete(`/eventos/${id}`)
    eventos.value = eventos.value.map(e => e.id === id ? { ...e, status: 'ARQUIVADO' } : e)
  }

  return { eventos, loading, fetchAll, getOne, create, update, archive, deletar }
})
